// ignore-string-externalization

import React from 'react';
import { Template, templateLoader, TemplateType } from '../features/Template';
import { getLanguage } from './_app';

export type Props = {
  // injected by the _app component
  activeSession?: boolean;
  locale: string;
  preview: boolean;
  home: TemplateType | null;
};

export const getServerSideProps = async ({ locale, preview }: Props) => {
  const retVal = {
    props: {
      home: await templateLoader.load({
        contentType: 'landingPage',
        urlSlug: 'home',
        smartlingLanguage: getLanguage(locale),
        preview,
      }),
    },
  };
  // if home is falsy (null or undefined)
  // if there's no contentType
  // we assume no valid content to show
  // and thus cannot be used to render page
  if (!retVal.props?.home?.contentType) {
    return {
      redirect: {
        destination: '/errors/contentError',
        permanent: false,
      },
      props: {},
    };
  }
  return retVal;
};

export default function HomePage({ home }: Props) {
  return (
    <>
      {home && (
        <>
          <Template
            {...home}
            requiredFeatureFlag={undefined}
            data-testid="landing-home"
            canonicalUrl="/"
          />
        </>
      )}
    </>
  );
}
